import { Center, Icon, Text, VStack } from "@chakra-ui/react";
import { LuPenLine } from "react-icons/lu";
import { RouteObject } from "react-router-dom";
import InboxView from "./inbox";
import DirectMessagesView from ".";
import DirectMessageChatView from "./chat/index";
import DirectMessageGroupView from "./group/index";

function EmptyState() {
  return (
    <Center h="full">
      <VStack spacing="3" color="gray.500">
        <Icon as={LuPenLine} boxSize="8" />
        <Text>Select a conversation or start a new message</Text>
      </VStack>
    </Center>
  );
}

export default [
  {
    Component: DirectMessagesView,
    children: [
      { index: true, element: <EmptyState /> },
      { path: "inbox", element: <InboxView /> },
      { path: "group/:group", element: <DirectMessageGroupView /> },
      { path: ":pubkey", element: <DirectMessageChatView /> },
    ],
  },
] satisfies RouteObject[];
